import React, { useEffect, useState } from 'react';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorPerfiles from './selector';

export const SelectorPerfilesContainer = (props: any) => {
  
	const api = new UsuariosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [perfiles, setPerfiles] = useState<any>([])
	let result: any;
  
  useEffect(()=>{
    getPerfiles();
  },[])

	const getPerfiles = async () => {
		try {
			result = await api.ListarPerfiles();
			if(result.data && result.data!=="")
			{
				setPerfiles([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <SelectorPerfiles {...props} data={perfiles}/>
};

export default SelectorPerfilesContainer;